export enum LeaveStatus {
    APPROVED = 'Approved',
    HR_APPROVED = 'Approved',
    RM_APPROVED = 'Approved',
    APPROVED_PM_RM = 'Approved by PM/RM',
    HR_REJECTED = 'Rejected by HR',
    RM_REJECTED = 'Rejected',
    PENDING = 'Pending',
    CANCELLATION_REQUESTED = 'Cancellation Requested',
    CANCELLATION_REJECTED = 'Cancellation Rejected',
    CANCELLED = 'Cancelled',
    DEFAULT = 'Default',
  }
  